import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.8_@opentelemetry+api@1.9.0_react-dom@19.1.2_react@19.1.2__react@19.1.2/node_modules/next/dist/client/image-component.js");
